export const findElement = (selector: string | null): Element | null => {
  if (!selector) {
    return null;
  }

  // 1. Try to find the element by ID
  let element = document.getElementById(selector);

  // 2. If not found, try any selector (ID, class, tag, etc.)
  if (!element) {
    element = document.querySelector(selector);
  }

  // 3. If still not found, try finding it by class name
  if (!element) {
    element = document.querySelector(`.${selector}`);
  }

  return element;
};

export const scrollTo = (element: Element | null | undefined, event: Event) => {
  event.preventDefault();
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest'
  });
  (element as HTMLElement).focus();
};
